"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOwners = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var cachedResult = null;

var fetchOwners = function fetchOwners() {
  if (cachedResult !== null) {
    return cachedResult;
  }

  cachedResult = _apiClient.default.get('self-service/v2/owner');
  return cachedResult;
};

exports.fetchOwners = fetchOwners;